import React from "react";
import {
  FormControl,
  FormLabel,
  Select as ChakraSelect,
} from "@chakra-ui/react";

const Select = ({
  options,
  handleChange,
  value,
  label,
  loading,
}: {
  options: string[] | number[];
  handleChange: (e: any) => void;
  value: string | number;
  label: string;
  loading?: boolean;
}) => {
  return (
    <FormControl>
      <FormLabel htmlFor="class">{label}</FormLabel>
      <ChakraSelect
        onChange={handleChange}
        value={typeof value === "string" ? value.toLowerCase() : value}
      >
        <option value="">Select</option>
        {loading ? (
          <option value="" disabled>
            loading...
          </option>
        ) : (
          options.map((option: string | number, index: number) => (
            <option
              key={index}
              value={typeof option === "string" ? option.toLowerCase() : option}
            >
              {option}
            </option>
          ))
        )}
      </ChakraSelect>
    </FormControl>
  );
};

export default Select;
